var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tooltip",
    {
      staticClass: "item",
      attrs: {
        disabled:
          _vm.tips === "" || _vm.tips === null || _vm.tips === undefined,
        effect: "dark",
        content: _vm.tips,
        placement: "top",
      },
    },
    [
      _c("el-input", {
        staticStyle: { display: "none" },
        attrs: {
          type: "hidden",
          size: "small",
          disabled: _vm.disabled,
          "show-word-limit": "",
        },
        on: { input: _vm.input },
        model: {
          value: _vm.val,
          callback: function ($$v) {
            _vm.val = $$v
          },
          expression: "val",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }